import Vue from "vue";
import Router from "vue-router";
import Home from "./views/Home.vue";
import Login from "./views/Login.vue";
import Error from "./views/Error.vue";
import CreateUser from "./views/user/Create.vue";
import store from "@/store"

Vue.use(Router);

const ADMINS = ['admin','superadmin'];

export const router = new Router({
  mode: "history",
  routes: [
    { path: '/', redirect: '/login' },
    {
      path: '/403', 
      name: 'unauthorized', 
      component: Error,
      meta: {
        hidden: true
      }
    },
    {
      path: "/login",
      name: "login",
      meta: {
        hideLayout: true,
        requiresNoAuth: true,
      },
      component: Login
    },
    {
      path: "/forgot/:id",
      name: "reset",
      meta: {
        hideLayout: true,
        hidden: true,
        requiresNoAuth: true,
      },
      component: () => import("./views/ResetPassword.vue")
    },
    {
      path: "/forgot",
      name: "forgot",
      meta: {
        hideLayout: true,
        requiresNoAuth: true,
      },
      component: () => import("./views/ForgotPassword.vue")
    },
    {
      path: "/register",
      name: "register",
      meta: {
        hidden: true,
        hideLayout: true,
        // requiresNoAuth: true,
      },
      component: () => import("./views/register/Register.vue")
    },
    {
      path: "/dashboard/:id",
      name: "dashboard",
      meta: {
        requiresAuth: true,
        hidden: true,
        showBanner: true
      },
      component: () => import("./views/Dashboard.vue")
    },
    {
      path: "/dashboard",
      name: "dashboard",
      meta: {
        requiresAuth: true,
        showBanner: true
      },
      component: () => import("./views/Dashboard.vue")
    },
    {
      path: "/premium",
      name: "premium",
      meta: {
        requiresAuth: true,
        // icon: 'alert-white.svg',
        showBanner: true
      },
      component: () => import("./views/premium/Premium.vue")
    },
    {
      path: "/terms-and-conditions",
      name: "terms-and-conditions",
      meta: {
        requiresAuth: true,
        showBanner: true
      },
      component: () => import("./views/TermsAndConditions.vue")
    },
    {
      path: "/premium/success",
      name: "premium_success",
      meta: {
        requiresAuth: true,
        showBanner: true,
        hidden: true
      },
      component: () => import("./views/premium/PremiumSuccess.vue")
    },
    {
      path: "/account",
      name: "account",
      redirect: '/account/my-account',
      meta: {
        requiresAuth: true
      },
      children: [
        {
          path: "my-account",
          name: "my_account",
          meta: {
            requiresAuth: true,
          },
          component: () => import("./views/user/MyAccount.vue")
        }
      ],
      component: () => import("./views/Index.vue")
    },
    {
      path: "/users",
      name: "users",
      redirect: '/users/view-users',
      meta: {
        requiresAuth: true,
        requiresRole: 'admin',
        description: 'Users description'
      },
      children: [
        {
          path: 'create-user',
          name: 'create_user',
          component: CreateUser,
          meta: {
            requiresAuth: true,
            requiresRole: 'admin',
          },
        },
        {
          path: 'view-users',
          name: 'view_users',
          component: () => import("./views/user/View.vue"),
          meta: {
            requiresAuth: true,
            requiresRole: 'admin',
          },
        },
        {
          path: 'view-enabled-users',
          name: 'view_enabled_users',
          component: () => import("./views/user/View.vue"),
          meta: {
            requiresAuth: true,
            requiresRole: 'admin',
            filter: { 
              name: 'active',
              value: true 
            }
          },
        },
        {
          path: 'view-disabled-users',
          name: 'view_disabled_users',
          component: () => import("./views/user/View.vue"),
          meta: {
            requiresAuth: true,
            requiresRole: 'admin',
            filter: { 
              name: 'active',
              value: false 
            }
          },
        },
        {
          path: ':id',
          name: 'single_user',
          component: () => import("./views/user/Single.vue"),
          meta: {
            requiresAuth: true,
            hidden: true,
            requiresRole: 'admin',
          },
        },
      ],
      component: () => import("./views/Index.vue")
    },
    {
      path: '/suggestion/:id',
      name: 'single_suggestion',
      component: () => import("./views/suggestion/Single.vue"),
      meta: {
        requiresAuth: true,
        hidden: true,
        requiresRole: 'admin',
      },
    },
    {
      component: () => import("./views/Index.vue"),
      path: "/my-documents",
      name: "my_documents",
      redirect: '/my-documents/uploaded-documents',
      meta: {
        requiresAuth: true
      },
      children: [
        {
          path: 'uploaded-documents',
          name: 'uploaded_documents',
          component: () => import("./views/document/Uploaded.vue"),
          meta: {
            requiresAuth: true,
          },
        },
        {
          path: 'upload-document',
          name: 'upload_document',
          component: () => import("./views/document/Upload.vue"),
          meta: {
            requiresAuth: true,
          },
        }
      ]
    },
    {
      path: "/documents",
      name: "documents",
      redirect: '/documents/view-documents',
      meta: {
        requiresAuth: true,
        requiresRole: 'admin'
      },
      children: [
        {
          path: 'create-document',
          name: 'create_document',
          component: () => import("./views/document/Create.vue"),
          meta: {
            requiresAuth: true,
            requiresRole: 'admin',
          },
        },
        {
          path: 'view-documents',
          name: 'view_documents',
          component: () => import("./views/document/View.vue"),
          meta: {
            requiresAuth: true,
            requiresRole: 'admin',
          },
        },
        {
          path: ':id',
          name: 'single_document',
          component: () => import("./views/document/Single.vue"),
          meta: {
            requiresAuth: true,
            hidden: true,
            requiresRole: 'admin',
          },
        }
      ],
      component: () => import("./views/Index.vue")
    },
    {
      path: '*', 
      name: 'unauthorized', 
      component: Error,
      meta: {
        hidden: true
      }
    },
  ]
});


router.beforeEach((to, from, next) => {
  async function checkAuth() {
    // console.log('CheckAuth')
    try {
      let STATE_USER = store.state.user;
      if(STATE_USER) {
        var t1 = new Date();
        var t2 = new Date(STATE_USER.expiry);
        var dif = t1.getTime() - t2.getTime();
        
        var Seconds_from_T1_to_T2 = dif / 1000;
        var Seconds_Between_Dates = Math.abs(Seconds_from_T1_to_T2 / 60);
        Seconds_Between_Dates = Seconds_Between_Dates.toFixed(2);

        if(t1 > t2) {
          // console.log('Token Expiry.. login redirect')
          store.dispatch('setToken', null)
          store.dispatch('setUser', null)
          return next('/403');
        } else {
          // console.log(t1 + " : " + t2);
          console.log(Seconds_Between_Dates + ' minutes expiry remaining' )
        }
      }
      
      if (to.meta.requiresAuth == true) {
        // console.log('// CheckAuth Router.. requiresAuth')
        if(to.meta.requiresRole) {
          if(STATE_USER == null)
            return next('/403');

          if(STATE_USER.role != to.meta.requiresRole && !ADMINS.includes(STATE_USER.role))
            return next('/403');
        }

        if(STATE_USER == null) {
          // router.push('/login');
          return next('/login');
        }

      }

      if(to.meta.requiresNoAuth == true) {
        if(STATE_USER != null) {
          // console.log('requiresNoAuth TRUE')
          // router.push('dashboard');
          return next('/dashboard');
        }
      }

      if(to.name) {
        document.title = router.app.$t('pages.' + to.name + '.title') || 'PPHR';
      }

      next()
    } catch(error) {
      // console.log(error)
      if(error.response.status == 403) {
        store.dispatch('setToken', null)
        store.dispatch('setUser', null)

        if(!to.meta.requiresAuth) {
          return next();
        }
        router.push('/login');
      }
    }
    next();
  }
  checkAuth();
  next();
})